<div class="content-body">
  <div class="row">
    <div class="col-lg-12">
      <p class="disinfo">Invoice Information</p>

      <ng-container *ngIf="disputeData">
        <p style="border-bottom: 1px solid #d1d1d1; padding-top: 5px">
          Details
        </p>

        <div class="row d-flex justify-content-between mt-4 mb-3 invoice-details-section-1">
          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
            <h6>Account No.</h6>
            <p>{{ disputeData.bpNo }}</p>
          </div>
          <ng-container *ngIf="isInvoiceDispute">
          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
            <h6>Invoice No.</h6>
            <p>{{ disputeData.invoice_id }}</p>
          </div>

          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
            <h6>Bill Date</h6>
            <p>{{ disputeData.date | date : "MM/dd/yyyy" }}</p>
          </div>
          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
            <h6>Due Date</h6>
            <p>{{ disputeData.dueDate | date : "MM/dd/yyyy" }}</p>
          </div>
        </ng-container>
        </div>
      </ng-container>
        <p style="border-bottom: 1px solid #d1d1d1">Address</p>
        
        <div class="row d-flex justify-content-between mt-4 mb-3 invoice-details-section-2">
          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head">
            <h6>From</h6>
            Brightspeed<br />
            P.O. Box 2677<br />
            Fayetteville, NC 28302-2677
          </div>
          <div class="col-sm-12 col-md-3 ac-inner-head ac-inv-head" *ngIf="disputeData && isInvoiceDispute">
            <h6>To</h6>
            {{ disputeData.businessPartnerName }}<br />
            {{ disputeData.StreetName }}<br />
            {{ disputeData.CityName }}, {{ disputeData.region }}
            {{ disputeData.zipCode }}
          </div>
          <div class="col-sm-12 col-md-3 desktop-view"></div>
          <div class="col-sm-12 col-md-3 desktop-view"></div>
        </div>
    </div>
  </div>

  <form class="g-2 mt-4 gx-5 formcss" [formGroup]="disputeForm">
    <p class="disinfo">Dispute Information</p>
    <div style="margin-bottom: 15px;">
      <span style="color: red;">
        Please enter your contact details (First Name, Last Name, Email Address, and Phone Number) in the Notes section.
      </span>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox" *ngIf="isInvoiceDispute">
          <label class="pb-2">Invoice Number</label>
          <input
            type="text"
            [placeholder]="iId"
            [(ngModel)]="iId"
            class="form-control"
            formControlName="iNumber"
            readonly
            [ngClass]="{ 'is-invalid': submitted && f['iNumber'].errors }"
          />
        </div>

        <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
          <label class="pb-2">Disputed Amount *</label>
          <div class="ac-inputbox">
            <span
              class="ac-mob-lineh"
              style="position: absolute; margin: 7px 0px 0px 12px"
              >{{ currency | currencySymbol }}</span
            >
            <input
              type="number"
              style="padding-left: 1.5rem"
              class="form-control"
              step="any"
              [(ngModel)]="amount"
              (change)="formatAmount()"
              formControlName="amount"
              [ngClass]="{ 'is-invalid': submitted && f['amount'].errors }"
            />
          </div>
          <div
            *ngIf="submitted && f['amount'].errors"
            class="text-danger fs-13 mt-1 ng-star-inserted"
          >
            <div *ngIf="f['amount'].errors['required']">
              <span class="mr-1 ac-error"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                    fill="#FA4628"
                  /></svg></span
              ><span class="text-danger">Please Enter Dispute Amount</span>
            </div>
          </div>
        </div>

        <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
          <label class="pb-2">Dispute Type *</label>

          <div ngbDropdown class="mySelectArrow">
            <button
              class="btn btn-outline-secondary"
              id="dropdownDisputeType"
              ngbDropdownToggle
            >
              {{ selectedDisputeType || "Select An Option" }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownDisputeType">
              <button
                ngbDropdownItem
                *ngFor="let type of DisputeTypeMap | keyvalue; index as i"
                (click)="selectDisputeType(type.key, type.value)"
              >
                {{ type.key }}
              </button>
            </div>
          </div>

          <div
            *ngIf="submitted && f['type'].errors"
            class="fs-13 mt-1 ng-star-inserted"
          >
            <div *ngIf="f['type'].errors['required']">
              <span class="mr-1 ac-error"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                    fill="#FA4628"
                  /></svg></span
              ><span class="text-danger">Please Enter Dispute Type</span>
            </div>
          </div>
        </div>
        <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
          <label class="pb-2">Priority *</label>

          <div ngbDropdown class="mySelectArrow">
            <button
              class="btn btn-outline-secondary"
              id="dropdownPriority"
              ngbDropdownToggle
            >
              {{ selectedPriority || "Select An Option" }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownPriority">
              <button
                ngbDropdownItem
                *ngFor="let type of DisputePriority | keyvalue; index as i"
                (click)="selectPriority(type.key, type.value)"
              >
                {{ type.key }}
              </button>
            </div>
          </div>
          <div
            *ngIf="submitted && f['priority'].errors"
            class="fs-13 mt-1 ng-star-inserted"
          >
            <div *ngIf="f['priority'].errors['required']">
              <span class="mr-1 ac-error"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                    fill="#FA4628"
                  /></svg></span
              ><span class="text-danger">Please Enter Priority</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-6">
        <div
          class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox"
          *ngIf="itemNumber != '0'"
        >
          <label class="pb-2">Item Number</label>
          <input
            type="text"
            [placeholder]="itemNumber"
            [(ngModel)]="itemNumber"
            class="form-control"
            formControlName="itemNumber"
            readonly
            [ngClass]="{
              'is-invalid': submitted && f['itemNumber'].errors
            }"
          />
        </div>
        <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
          <label class="pb-2">Reason *</label>

          <div ngbDropdown class="mySelectArrow col-sm-12">
            <button
              class="btn btn-outline-secondary"
              id="dropdownReason"
              ngbDropdownToggle
            >
              {{ selectedReason || "Select An Option" }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownReason">
              <button
                ngbDropdownItem
                *ngFor="let type of DisputeReasonMap | keyvalue; index as i"
                (click)="selectReason(type.key, type.value)"
              >
                {{ type.key }}
              </button>
            </div>
          </div>

          <div
            *ngIf="submitted && f['reason'].errors"
            class="fs-13 mt-1 ng-star-inserted"
          >
            <div *ngIf="f['reason'].errors['required']">
              <span class="mr-1 ac-error"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                    fill="#FA4628"
                  /></svg></span
              ><span class="text-danger">Please Enter Reason</span>
            </div>
          </div>
        </div>

        <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
          <label class="pb-2">Add Attachement</label>
          
          <input
          type="file"
          id="fileInput"
          (change)="fileChange($event)"
          placeholder=""
          class="form-control"
          />
          <div class="upload-file">
            <input type="button" onclick="document.getElementById('fileInput').click()" value="Choose File" />
            <div class="fileName" ngbTooltip="{{fileName}}">{{fileName || 'No file chosen'}}</div>
          </div>
        </div>

        <div class="form-group col-sm-12 width70 mb-4 pb-1 ac-inputbox">
          <label class="pb-2">
            Customer Note *
            <small *ngIf="!isInvoiceDispute"
              ><span style="color: red"
                >Disclaimer: Please include the invoice numbers that are related to your dispute.</span
              ></small
            >
          </label>

          <textarea
            formControlName="note"
            placeholder="Add note here..."
            style="padding: 5px 10px"
            maxlength="132"
            [ngClass]="{ 'is-invalid': submitted && f['note'].errors }"
          ></textarea>

          <div
            *ngIf="submitted && f['note'].errors"
            class="text-danger fs-13 ng-star-inserted"
          >
            <div *ngIf="f['note'].errors['required']">
              <span class="mr-1 ac-error"
                ><svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                    fill="#FA4628"
                  /></svg></span
              ><span class="text-danger">Please Enter Note</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group m-4 pb-1" style="text-align: end">
      <button
        class="btn ac-btn-primary mb-sm-0 mb-2 float-right"
        (click)="saveDispute()"
      >
        Save and Proceed
      </button>
    </div>
  </form>
</div>
